import { RequiredTranslationsTemplate } from '.'

const bg: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Български',
  },
  home: {
    title: 'ИЗТЕГЛЯНЕ НА ПРОДУКТ ROCKRIDER XC 500 S',
    description:
      'Благодарим Ви, че купихте планински велосипед ROCKRIDER XC 500 S. Установихме потенциална слабост на нивото на вилката. Засегнати са само някои серийни номера. Приканваме Ви да въведете последните 6 цифри на серийния номер, за да разберете дали Вашият велосипед попада в обхвата на тази кампания за изтегляне.',
    form: {
      title: 'Въведете следните данни:',
      fields: {
        serialNumber: 'Сериен №:',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Собствено име',
        lastName: 'Фамилно име',
        email: 'Имейл',
        phone: 'Телефон',
        country: 'Държава',
        submit: 'Потвърди',
        choose: 'Избери',
      },
      errors: {
        requiredField: 'Това поле е задължително',
        unknownSerialNumber: 'Неизвестен сериен номер',
        provide6Numbers: 'Моля, имайте предвид, че се изискват 6 цифри.',
      },
      confirmations: {
        good: {
          title: 'Вашият велосипед не е засегнат',
          p1: 'Информираме Ви, че Вашият велосипед не е засегнат от това изтегляне и можете да продължите да го използвате без никаква опасност.',
          p2: 'Извиняваме се за евентуално причинените неудобства.',
          p3: 'Спортни поздрави,',
          p4: 'Екипът на Decathlon',
        },
        defective: {
          title: 'Вашият велосипед е засегнат.',
          p1: 'Приканваме Ви повече да не го използвате и да се обърнете към Сервиза на най-близкия магазин, за да се пристъпи към смяна на вилката.',
          p2: 'Обръщаме Ви внимание, че продуктът може да бъде извън движение няколко дни. Ще направим всичко възможно да намалим до минимум това забавяне. Съветваме Ви да проверите директно в Сервиза на магазина за ориентировъчния срок на ремонта.',
          p3: 'Потърсете най-близкия до Вас Сервиз на Decathlon:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'По-долу ще намерите талон за поправка, който да представите в Сервиза:',
          p5: 'За повече информация се свържете с нашия Център за обслужване на клиенти на Decathlon на телефон 02 902 10 70 от понеделник до неделя от 09:00 до 18:00 часа.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Къде можете да видите серийния номер',
      description: 'Серийният номер е изписан върху вилката.',
    },
  },
}

export default bg
